import React from "react";
import { Route } from "react-router-dom";
import PhotoGallery from "@zillout/shared-components/dist/components/PhotoGallary";
import { env } from "../config/env";

export const galleryRoutes = (
  <Route
    path="/gallery"
    element={
      <PhotoGallery appContext="experience" pubId={env.REACT_APP_PLACE_ID} />
    }
  />
);
